function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M310.805,268.65h-44.84c-9.267-0.006-18.377,2.392-26.44,6.96c-6.863,3.893-12.8,9.229-17.4,15.64 c-3.064-0.535-6.169-0.802-9.28-0.8h-44.88c-3.111-0.003-6.216,0.265-9.28,0.8c-4.599-6.412-10.536-11.748-17.4-15.64 c-8.063-4.568-17.173-6.966-26.44-6.96h-44.84c-29.796,0.066-53.934,24.204-54,54v30.44c0.022,3.188,2.612,5.76,5.8,5.76h92v16 c0,3.203,2.597,5.8,5.8,5.8h141.44c3.203,0,5.8-2.597,5.8-5.8v-16h92c3.203,0,5.8-2.597,5.8-5.8v-30.4 C364.579,292.916,340.538,268.804,310.805,268.65z M114.405,339.25v1.24c0,0.56,0,1.08,0,1.64v2.32v2.8h-86.8v-24.6 c0.066-23.39,19.01-42.334,42.4-42.4h44.84c7.261-0.008,14.4,1.866,20.72,5.44c4.237,2.396,8.038,5.494,11.24,9.16 C128.756,302.684,116.36,319.672,114.405,339.25z M255.125,344.45v24.64h-129.56v-25.08c0-0.453,0-0.893,0-1.32 c0-0.693,0-1.387,0-2.08v-1.04c0-0.4,0-0.8,0-1.2v-1.28v-0.4v-0.44v-0.88l0.24-0.96l0.4-1.44l0.28-0.96 c5.746-17.415,21.982-29.206,40.32-29.28l1.16-0.64h44.88c21.297,0.078,39.258,15.885,42.04,37c0,0.88,0,1.76,0.24,2.64 C255.125,342.637,255.125,343.543,255.125,344.45z M353.205,347.29h-86.4v-3.48c0-0.44,0-0.88,0-1.32c0-0.453,0-0.907,0-1.36 c0-0.64,0-1.32,0-1.96v-0.6v-0.68v-1.24v-0.2v-0.48v-0.44v-0.28v-0.52v-0.56v-0.28v-0.36v-0.36v-0.36v-0.88v-0.4v-0.52v-0.52 l-0.28-1v-0.4v-0.36v-0.28v-0.4v-0.52l-0.56-1.56c-5.212-13.855-15.842-24.99-29.44-30.84c2.406-3.562,5.332-6.744,8.68-9.44 c6.32-3.574,13.459-5.448,20.72-5.44h44.88c23.389,0.066,42.334,19.01,42.4,42.4V347.29z"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("circle", {
  cx: 190.645,
  cy: 77.85,
  r: 6.56
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M121.285,189.17c-7.643-7.688-18.039-12.008-28.88-12c-22.555-0.02-40.856,18.248-40.876,40.804 c-0.02,22.555,18.248,40.856,40.804,40.876s40.856-18.248,40.876-40.804C133.218,207.221,128.93,196.835,121.285,189.17z M113.085,238.65c-11.417,11.421-29.93,11.425-41.352,0.008c-11.421-11.417-11.425-29.93-0.008-41.352 c11.417-11.421,29.93-11.425,41.352-0.008c5.484,5.482,8.566,12.918,8.568,20.672C121.656,225.728,118.576,233.17,113.085,238.65z "
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("circle", {
  cx: 233.045,
  cy: 77.85,
  r: 6.56
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M258.725,22.73c-19.566-15.048-43.638-23.053-68.32-22.72c-24.682-0.333-48.753,7.672-68.32,22.72 c-17.92,14.32-29,34.24-29,56.28c0.022,11.194,2.87,22.201,8.28,32c5.148,9.257,12.066,17.412,20.36,24l-4.6,30.6 c-0.479,3.145,1.683,6.082,4.828,6.561c1.303,0.198,2.634-0.056,3.772-0.721l31.28-18.24c4.957,1.474,10.009,2.61,15.12,3.4 c6.062,0.934,12.187,1.402,18.32,1.4c24.682,0.333,48.754-7.672,68.32-22.72c17.88-14.36,28.96-34.24,28.96-56.28 S276.645,37.05,258.725,22.73z M251.525,126.33c-17.545,13.349-39.077,20.395-61.12,20c-5.53,0.008-11.053-0.406-16.52-1.24 c-5.424-0.811-10.774-2.055-16-3.72c-1.551-0.489-3.236-0.301-4.64,0.52l-22.84,13.48l3.32-22c0.317-2.149-0.594-4.295-2.36-5.56 c-8.204-5.937-15.027-13.578-20-22.4c-4.448-8.089-6.786-17.169-6.8-26.4c0-18.4,9.4-35.12,24.6-47.28 c17.545-13.349,39.077-20.395,61.12-20c22.043-0.395,43.575,6.651,61.12,20c15.2,12,24.6,28.88,24.6,47.28 C276.005,97.41,266.725,114.13,251.525,126.33z"
})));

var _ref6 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M288.438,177.13c-22.555-0.02-40.856,18.248-40.876,40.804c-0.01,10.825,4.279,21.212,11.924,28.876 c7.643,7.688,18.039,12.008,28.88,12c22.555,0.02,40.856-18.248,40.876-40.804S310.993,177.15,288.438,177.13z M309.085,238.633 c-11.417,11.421-29.93,11.425-41.352,0.008c-5.484-5.482-8.566-12.918-8.568-20.672c-0.011-7.758,3.069-15.2,8.56-20.68 c11.417-11.421,29.93-11.425,41.352-0.008C320.498,208.698,320.502,227.212,309.085,238.633z"
})));

var _ref7 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("circle", {
  cx: 148.245,
  cy: 77.85,
  r: 6.56
})));

var _ref8 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M219.225,210.83c-7.652-7.626-18.017-11.905-28.82-11.9c-10.841-0.008-21.237,4.312-28.88,12 c-15.906,15.961-15.861,41.794,0.1,57.7c15.961,15.906,41.794,15.861,57.7-0.1S235.186,226.736,219.225,210.83z M190.397,269.042 c-16.149-0.005-29.236-13.1-29.232-29.248s13.1-29.236,29.248-29.232c7.754,0.002,15.19,3.084,20.672,8.568 c5.491,5.48,8.571,12.922,8.56,20.68C219.64,255.959,206.545,269.046,190.397,269.042z"
})));

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var _ref19 =
/*#__PURE__*/
React.createElement("g", null);

var _ref20 =
/*#__PURE__*/
React.createElement("g", null);

var _ref21 =
/*#__PURE__*/
React.createElement("g", null);

var _ref22 =
/*#__PURE__*/
React.createElement("g", null);

var _ref23 =
/*#__PURE__*/
React.createElement("g", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 380.65 380.65",
    style: {
      "enableBackground": "new 0 0 380.65 380.65"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
};

export default __webpack_public_path__ + "static/media/group.d3324afd.svg";
export { SvgComponent as ReactComponent };